import { motion } from "framer-motion";
import { ExternalLink, ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface MerchandiseCatalogProps {
  storyId: number;
  storyTitle?: string;
}

export function MerchandiseCatalog({ storyId, storyTitle }: MerchandiseCatalogProps) {
  const handleSwagStoreClick = () => {
    const swagStoreUrl = import.meta.env.VITE_SWAG_STORE_URL || 'https://swag.snugglecrafters.com';
    window.open(swagStoreUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      className="mt-16 pb-8"
    >
      <Card className="max-w-2xl mx-auto">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <div className="w-20 h-20 bg-gradient-to-r from-purple-600 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <ShoppingBag className="w-10 h-10 text-white" />
            </div>
            <h3 className="text-3xl font-bold text-gray-800 mb-3">
              Take the Magic Home!
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              Visit our swag store for exclusive <span className="text-snuggle-gradient">SnuggleCrafters</span> merchandise, toys, and gifts for bedtime story lovers.
            </p>
          </div>
          
          <Button 
            onClick={handleSwagStoreClick}
            className="bg-gradient-to-r from-purple-600 to-teal-600 text-white hover:shadow-lg text-lg px-8 py-3"
            size="lg"
            data-testid="button-swag-store"
          >
            <ShoppingBag className="w-5 h-5 mr-2" />
            Visit Our Swag Store
            <ExternalLink className="w-5 h-5 ml-2" />
          </Button>
          
          <p className="text-sm text-gray-500 mt-4">
            Find t-shirts, mugs, stickers, books, and more!
          </p>
        </CardContent>
      </Card>
    </motion.div>
  );
}